import { render, staticRenderFns } from "./ClientesEdit.vue?vue&type=template&id=519d6320&"
import script from "./ClientesEdit.vue?vue&type=script&lang=js&"
export * from "./ClientesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports